import React from 'react';
import { AssetNodeProps } from 'common/components/Graph/Models/AssetNodeProps';
import { BaseInternetNode, PUBLIC_IPS_NODE_TITLE } from './BaseInternetNode';

const PartialNode: React.FC<AssetNodeProps> = (props: AssetNodeProps) => {
    return <BaseInternetNode nodeProps={props} title={PUBLIC_IPS_NODE_TITLE} iconName={'semiPublic'} />;
};

export default PartialNode;
